import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Col, Row } from "styles";
import { Table } from "../../style";

export function PhytaseHidosing(props) {
  return (
    <>
      <Row>
        <Col>
          <Table>
            <Header>
              <tr>
                <th style={{ width: "185px" }}>
                  <span></span>
                </th>
                <th>
                  <span>Qual tipo?</span>
                </th>
                <th>
                  <span>Qual Produto?</span>
                </th>
                <th>
                  <span>Qual dose?</span>
                </th>
              </tr>
            </Header>
            <Body>
              <tr>
                <td>Pré Postura</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.preLay.type"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Tipo"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.preLay.product"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.preLay.dose"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                  />
                </td>
              </tr>
              <tr>
                <td>Pré Pico</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.prePeak.type"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Tipo"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.prePeak.product"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.prePeak.dose"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                  />
                </td>
              </tr>
              <tr>
                <td>Pico de Postura</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layPeak.type"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Tipo"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layPeak.product"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layPeak.dose"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                  />
                </td>
              </tr>
              <tr>
                <td>Postura 01</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal01.type"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Tipo"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal01.product"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal01.dose"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                  />
                </td>
              </tr>
              <tr>
                <td>Postura 02</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal02.type"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Tipo"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal02.product"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal02.dose"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                  />
                </td>
              </tr>
              <tr>
                <td>Postura 03</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal03.type"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Tipo"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal03.product"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal03.dose"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                  />
                </td>
              </tr>
              <tr>
                <td>Postura 04</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal04.type"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Tipo"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal04.product"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal04.dose"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                  />
                </td>
              </tr>
              <tr>
                <td>Postura 05</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal05.type"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Tipo"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal05.product"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal05.dose"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                  />
                </td>
              </tr>
              <tr>
                <td>Postura 06</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal06.type"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Tipo"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal06.product"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.layFinal06.dose"
                    item={props.meggProduction}
                    setItem={props.setMeggProduction}
                  />
                </td>
              </tr>
            </Body>
          </Table>
        </Col>
      </Row>
      <Row>
        <Col>
          <label>Microtech está aprovada? Se não, por qual motivo?</label>
          <Input
            type="checkbox"
            params="enzymes.phytaseHidosing.approved.checked"
            item={props.meggProduction}
            setItem={props.setMeggProduction}
            label="Aprovado"
          />
          <Input
            type="input"
            label=" "
            params="enzymes.phytaseHidosing.approved.reason"
            item={props.meggProduction}
            setItem={props.setMeggProduction}
            disabled={
              props.meggProduction.enzymes.phytaseHidosing.approved.checked
            }
            placeholder="Digite o motivo"
          />
        </Col>
      </Row>
    </>
  );
}
